import React from 'react';
import '../styles.scss';
import { AppLayout } from '../../app/components/AppLayout';
import { Links } from './Links';
import { DeleteButton } from './DeleteButton';
import { ActivateButton } from './ActivateButton';
import { EditButton } from './EditButton';
import { LinkModal } from './LinkModal';
import { PageTabs } from '../../app/components/PageTabs';
import { Search } from './Search';

export const SharingLinksPage = () => {
  return (
    <AppLayout leftSider={false} rightSider={false}>
      <LinkModal />

      <div className="al-sharing-links-page">
        <div className="al-sharing-links-page-top">
          <div className="al-sharing-links-page-top__left">
            <DeleteButton />
            <ActivateButton />
            <EditButton />
            <Search />
          </div>
          <PageTabs />
        </div>

        <Links />
      </div>
    </AppLayout>
  );
};
